<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalDialogStore } from '@/stores/use-global-dialog-store'

const { globalDialogData, isDialogShow } = storeToRefs(useGlobalDialogStore())
const { closeGlobalDialog } = useGlobalDialogStore()
</script>

<template>
  <app-modal
    :modal-title="globalDialogData?.title"
    :model-value="isDialogShow"
    :size="'lg'"
    @modal-hidden="closeGlobalDialog"
  >
    <div class="w-100 d-flex justify-content-center">
      {{ globalDialogData?.content }}
    </div>
    <template #footer>
      <button
        class="btn btn-outline-primary"
        type="button"
        :aria-label="$t('Common.AppModal.ClosePopup')"
        @click="closeGlobalDialog"
        @keydown="closeGlobalDialog"
      >
        {{ $t('Common.AppModal.Close') }}
      </button>
    </template>
  </app-modal>
</template>
